<app-page-header [title]="'Studios'" [subtitle]="'Manage studios for SampleStudio'"></app-page-header>

<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input
                        pInputText
                        id="studio_search"
                        [(ngModel)]="this.search"
                        (input)="onSearchInputChange()"
                        autocomplete="off"
                />
            </p-iconfield>
            <label for="studio_search">Search studio</label>
        </p-ifta-label>
        <p-button label="Add Studio" icon="pi pi-plus" (click)="openCreateDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>

    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.studios"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Hostname</th>
                    <th>State</th>
                    <th>Dealership</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-studio>
                <tr>
                    <td>{{ studio.name }}</td>
                    <td>{{ studio.hostname }}</td>
                    <td>
                        <p-tag
                                [severity]="studio.state === 'ONLINE' ? 'success' : studio.state === 'OFFLINE' ? 'danger' : 'secondary'"
                                [value]="studio.state | enumLabel"
                        ></p-tag>
                    </td>
                    <td>{{ studio.dealership?.name }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View studio"
                                      tooltipPosition="left"
                                      routerLink="/studios/studio/{{studio.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit studio"
                                      tooltipPosition="left"
                                      (click)="editStudio(studio)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete studio"
                                      tooltipPosition="left"
                                      (click)="deleteStudio(studio)"
                                      severity="danger"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<div class="flex gap-2 mb-6">
    <p-button label="Export Studios" icon="pi pi-download" (click)="exportStudios()" severity="secondary"></p-button>
</div>

<!-- Create Studio Dialog -->
<app-create-studio-dialog
        [(visible)]="this.displayCreateDialog"
        (studioCreated)="reloadStudios()"
></app-create-studio-dialog>

<!-- Update Studio Dialog -->
<app-update-studio-dialog
        [(visible)]="this.displayUpdateDialog"
        [studio]="this.selectedStudio"
        (studioUpdated)="reloadStudios()"
></app-update-studio-dialog>
